
export default {
  name: "SearchBar",
  props: {
    value: String,
    readonly: Boolean,
    placeholder: { type: String, default: "" },
  },
  computed: {
    _placeholder() {
      return this.placeholder || this.$t("form.common.label.type2search");
    },
  },
  methods: {
    onInput(v) {
      this.$emit("input", v);
    },
  },
};
